import { useTranslation } from 'react-i18next';
import { FaChevronLeft, FaChevronRight, FaEllipsisH } from 'react-icons/fa';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
  className = '' 
}) => {
  const { t } = useTranslation('common');
  
  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    let prev = 0;
    for (const i of range) {
      if (prev !== 0 && i - prev !== 1) {
        rangeWithDots.push('ellipsis');
      }
      rangeWithDots.push(i);
      prev = i;
    }

    return rangeWithDots;
  };

  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className={`pagination-container ${className}`}>
      {/* Informations sur les résultats */}
      <div className="pagination-info">
        <span className="text-muted">
          {t('pagination.displaying')} <strong>{startItem}-{endItem}</strong> {t('pagination.of')}{' '}
          <strong>{totalCount.toLocaleString()}</strong> {t('pagination.results')}
        </span>
      </div>

      {/* Sélecteur de taille de page */}
      <div className="page-size-selector">
        <label htmlFor="pageSize" className="form-label-sm mb-0 me-2">
          {t('pagination.rowsPerPage')}:
        </label>
        <select
          id="pageSize"
          className="account-type-select"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          style={{ width: '80px' }}
        >
          {[10, 15, 25, 50, 100].map(size => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      {/* Navigation des pages */}
      <nav aria-label={t('pagination.ariaLabel')}>
        <ul className="pagination pagination-sm mb-0">
          {/* Bouton Précédent */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label={t('pagination.previous')}
            >
              <FaChevronLeft size={12} />
            </button>
          </li>

          {/* Numéros de page */}
          {getPageNumbers().map((page, index) => (
            <li
              key={index}
              className={`page-item ${
                page === currentPage ? 'active' : ''
              } ${page === 'ellipsis' ? 'disabled' : ''}`}
            >
              {page === 'ellipsis' ? (
                <span className="page-link">
                  <FaEllipsisH size={12} />
                </span>
              ) : (
                <button
                  className="page-link"
                  onClick={() => onPageChange(page)}
                  aria-label={`${t('pagination.page')} ${page}`}
                  aria-current={page === currentPage ? 'page' : undefined}
                >
                  {page}
                </button>
              )}
            </li>
          ))}

          {/* Bouton Suivant */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label={t('pagination.next')}
            >
              <FaChevronRight size={12} />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;